import {
  ButtonType,
  ButtonWidget,
  DialogPositioningBehavior,
  DialogType,
  TabStyles
} from '@tableau/widgets';
import React from 'react';

import { ReactModalOptions } from '~commonInfra/dialogs/ReactModalService';
import { CommonStyles } from '~commonInfra/styles/CommonStyles';

import { Messages } from '../../../codegen/Localize';

const DIALOG_WIDTH = 375;

export interface ResumeMetricErrorDialogProps {
  readonly submit: () => void;
  readonly cancel: () => void;
  readonly errorMessage: string;
}

export interface ResumeMetricErrorDialogState {
  readonly isSubmitting: boolean;
}

class ResumeMetricErrorDialog extends React.Component<ResumeMetricErrorDialogProps, ResumeMetricErrorDialogState> {
  constructor(props: ResumeMetricErrorDialogProps) {
    super(props);
    this.state = {
      isSubmitting: false
    };
  }

  private onSubmit = () => this.setState({ isSubmitting: true }, this.props.submit);

  private onCancel = () => this.setState({ isSubmitting: true }, this.props.cancel);

  public render(): React.ReactNode {
    return (
      <>
        <div style={ textStyle }>
          { this.props.errorMessage }
        </div>
        <div style={ buttonContainerStyle }>
          <ButtonWidget
            disabled={ this.state.isSubmitting }
            testId={'resume-metric-error-cancel'}
            buttonType={ ButtonType.Outline }
            style={ buttonStyle }
            handleClick={ this.onCancel }>
            <span>{ Messages.cancel() }</span>
          </ButtonWidget>
          <ButtonWidget
            disabled={ this.state.isSubmitting }
            testId={'resume-metric-error-delete'}
            buttonType={ ButtonType.Destructive }
            handleClick={ this.onSubmit }>
            <span>{ Messages.metricDeleteButtonLabel() }</span>
          </ButtonWidget>
        </div>
      </>
    );
  }
}

export function resumeMetricErrorModalOptions(props: ResumeMetricErrorDialogProps): ReactModalOptions {
  return {
    title: Messages.metricResumeErrorTitle(),
    testId:'resume-metric-error-dialog',
    type: DialogType.NormalWithTitleBar,
    showCloseButton: false,
    positioningBehavior: DialogPositioningBehavior.Centered,
    dialogWidth: DIALOG_WIDTH,
    dialogBodyStyle: dialogStyle,
    dialogContent: <ResumeMetricErrorDialog {...props} />
  };
}

const dialogStyle: React.CSSProperties = {
  paddingBottom: TabStyles.Spacing.MediumSpace,
};

const textStyle: React.CSSProperties = {
  fontSize: TabStyles.Typography.Sizing.Default,
  fontWeight: 'normal',
  color: CommonStyles.Colors.Grey51
};

const buttonContainerStyle: React.CSSProperties = {
  marginTop: TabStyles.Spacing.MediumSpace,
  float: 'right'
};

const buttonStyle: React.CSSProperties = {
  marginRight: TabStyles.Spacing.MediumSpace
};
